<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :z-index="200"
    content-class="date-selector-menu"
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-mask="'##/##/####'"
        :value="displayDate"
        clearable
        append-icon="mdi-calendar-month-outline"
        placeholder="__/__/____"
        persistent-placeholder
        inputmode="numeric"
        outlined
        hide-details
        dense
        :label="label"
        :error="invalidDate"
        @input="onTextInput"
        @blur="commitTypedDate"
        @keyup.enter="commitTypedDate"
        @keydown.esc="restoreDisplayDate"
        @click:append.stop="menu = true"
        @click:clear.stop="clearDate"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="date"
      no-title
      @input="selectCalendarDate"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "date-selector",

  props: {
    value: {
      default: null,
    },
    initValue: {
      default: null,
    },
    label: {
      type: String,
      default: "Date",
    },
    emptyDate: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      menu: false,
      date: "",
      displayDate: "",
      invalidDate: false,
    };
  },

  created() {
    const initialValue = this.initValue || this.value;

    if (this.emptyDate && !initialValue) {
      this.syncDate("");
      return;
    }

    this.syncDate(initialValue || new Date().toISOString());
  },

  watch: {
    initValue(value) {
      if (value !== null && value !== undefined) this.syncDate(value);
    },
    value(value) {
      if (value !== null && value !== undefined) this.syncDate(value);
    },
  },

  methods: {
    syncDate(value) {
      if (!value) {
        this.date = "";
        this.displayDate = "";
        this.invalidDate = false;
        return;
      }

      const parsedDate = this.$moment(value);
      if (!parsedDate.isValid()) return;

      this.date = parsedDate.format("YYYY-MM-DD");
      this.displayDate = parsedDate.format("MM/DD/YYYY");
      this.invalidDate = false;
    },

    onTextInput(value) {
      this.displayDate = value;
      this.invalidDate = false;
    },

    commitTypedDate() {
      const value = String(this.displayDate || "").trim();

      if (!value) {
        this.clearDate();
        return;
      }

      const parsedDate = this.$moment(
        value,
        ["MM/DD/YYYY", "M/D/YYYY", "YYYY-MM-DD"],
        true
      );

      if (!parsedDate.isValid()) {
        this.invalidDate = true;
        return;
      }

      this.applyDate(parsedDate);
    },

    selectCalendarDate(value) {
      const parsedDate = this.$moment(value, "YYYY-MM-DD", true);
      if (!parsedDate.isValid()) return;

      this.applyDate(parsedDate);
      this.menu = false;
    },

    applyDate(parsedDate) {
      this.date = parsedDate.format("YYYY-MM-DD");
      this.displayDate = parsedDate.format("MM/DD/YYYY");
      this.invalidDate = false;
      this.$emit("input", parsedDate.toISOString());
      this.$emit("change", parsedDate.toISOString());
    },

    restoreDisplayDate() {
      this.displayDate = this.date
        ? this.$moment(this.date, "YYYY-MM-DD").format("MM/DD/YYYY")
        : "";
      this.invalidDate = false;
    },

    clearDate() {
      this.date = "";
      this.displayDate = "";
      this.invalidDate = false;
      this.$emit("input", "");
      this.$emit("change", "");
    },
  },
};
</script>

<style>
.date-selector-menu {
  z-index: 2000 !important;
}
</style>
